import { useEffect } from 'react';

import { sendWsMessage } from '@/app/sagas/websocket';

export function useJoinGame(gameId: string): void {
  useEffect(() => {
    sendWsMessage({ type: 'join_game', data: { game_id: gameId } });
  }, [gameId]);
}
